<template>
  <div class="cgu-container">
    <h1 class="cgu-title">Conditions Générales d'Utilisation</h1>
    <p class="cgu-date">Date de dernière mise à jour : 05/05/2025</p>

    <section class="cgu-section">
      <h2>Préambule</h2>
      <p>Les présentes Conditions Générales d'Utilisation (ci-après les « CGU ») définissent les conditions d'accès et d'utilisation des services proposés sur le site internet Query Juriste, accessible à l'URL https://www.query-juriste.com (ci-après le « Site »).</p>
      <p>Le Site est édité par Query Juriste, société au capital de 100 euros, inscrite au R.C.S. de PARIS sous le numéro 929322261, dont le siège social est situé au 37 rue Rousselet, 75007 Paris, représentée par Etienne Leguay (ci-après « l'Exploitant »).</p>
      <p>L'utilisation du Site et des Services est subordonnée à l'acceptation sans réserve des présentes CGU. Tout accès et/ou utilisation du Site emporte de plein droit l'application des présentes CGU.</p>
    </section>

    <section class="cgu-section">
      <h2>Article 1 - Définitions</h2>
      <p>Dans les présentes CGU, les mots ou expressions commençant avec une majuscule auront la signification suivante :</p>
      <ul>
        <li><strong>Client</strong> : désigne toute personne physique ou morale qui s'inscrit sur le Site en vue d'utiliser les Services.</li>
        <li><strong>Compte</strong> : désigne l'espace personnel du Client sur le Site, accessible grâce à ses Identifiants.</li>
        <li><strong>Contenu</strong> : désigne l'ensemble des données, textes, images, photos, vidéos ou toute autre information publiée par l'Exploitant sur le Site.</li>
        <li><strong>Identifiants</strong> : désigne l'adresse email du Client et le mot de passe choisi par ce dernier, nécessaires à l'accès à son Compte sur le Site.</li>
        <li><strong>Services</strong> : désigne l'ensemble des services proposés par l'Exploitant sur le Site, notamment l'accès à une plateforme d'intelligence artificielle juridique permettant d'analyser des documents juridiques.</li>
      </ul>
    </section>

    <section class="cgu-section">
      <h2>Article 2 - Description des Services</h2>
      <p>Query Juriste est une plateforme SaaS européenne d'intelligence artificielle juridique conçue pour les professionnels du droit, notamment les avocats, les juristes d'entreprise et les directions juridiques.</p>
      <p>La plateforme permet d'analyser des centaines de documents juridiques en quelques minutes grâce à une architecture sophistiquée d'agents IA spécialisés et offre une interface intuitive pour accéder rapidement aux décisions de justice pertinentes, facilitant ainsi la prise de décisions juridiques.</p>
      <p>Le Site propose différentes formules d'abonnement permettant d'accéder aux Services, dont les caractéristiques et les prix sont indiqués sur le Site.</p>
    </section>

    <section class="cgu-section">
      <h2>Article 3 - Accès aux Services et création du Compte</h2>

      <h3>3.1 Conditions d'accès</h3>
      <p>L'accès aux Services nécessite que le Client dispose d'un accès à Internet. Tous les coûts afférents à l'accès aux Services, que ce soient les frais matériels, logiciels ou d'accès à Internet sont exclusivement à la charge du Client.</p>
      <p>L'accès aux Services peut être limité à un nombre maximal de requêtes par période, selon la formule d'abonnement choisie par le Client.</p>

      <h3>3.2 Création du Compte</h3>
      <p>Pour accéder aux Services, le Client doit créer un Compte en fournissant les informations marquées comme obligatoires dans le formulaire d'inscription, notamment son nom, prénom, adresse email professionnelle.</p>
      <p>Le Client s'engage à fournir des informations exactes, complètes et à jour. Toute information fausse, incomplète ou obsolète pourra entraîner la suspension ou la résiliation immédiate du Compte du Client.</p>
      <p>Une fois le formulaire d'inscription complété, le Client recevra un email de confirmation l'invitant à activer son Compte en cliquant sur le lien prévu à cet effet.</p>

      <h3>3.3 Identifiants</h3>
      <p>Les Identifiants sont personnels et confidentiels. Le Client est seul responsable de la préservation et de la confidentialité de ses Identifiants et des actions qui sont menées sous son Compte.</p>
      <p>Le Client s'engage à :</p>
      <ul>
        <li>Ne pas communiquer ses Identifiants à des tiers</li>
        <li>Ne pas créer de fausse identité de nature à induire l'Exploitant ou des tiers en erreur</li>
        <li>Informer immédiatement l'Exploitant de toute utilisation non autorisée de son Compte ou de toute autre violation de la sécurité</li>
      </ul>
      <p>L'Exploitant ne pourra être tenu responsable de toute perte ou dommage résultant du non-respect par le Client de ces obligations.</p>
    </section>

    <section class="cgu-section">
      <h2>Article 4 - Utilisation des Services</h2>

      <h3>4.1 Règles d'utilisation</h3>
      <p>Le Client s'engage à utiliser les Services conformément aux présentes CGU et à la législation applicable.</p>
      <p>En particulier, le Client s'engage à :</p>
      <ul>
        <li>Ne pas utiliser les Services à des fins illicites</li>
        <li>Ne pas tenter de perturber ou de compromettre l'intégrité ou la sécurité des Services</li>
        <li>Ne pas tenter de contourner les limitations d'utilisation des Services</li>
        <li>Ne pas utiliser de logiciels, dispositifs ou autres processus manuels ou automatiques pour "scraper" ou "spider" toute page du Site</li>
        <li>Ne pas réutiliser le contenu des Services à des fins commerciales sans l'autorisation préalable et écrite de l'Exploitant</li>
      </ul>

      <h3>4.2 Suspension ou restriction d'accès</h3>
      <p>L'Exploitant se réserve le droit de suspendre l'accès aux Services ou de restreindre les fonctionnalités accessibles à un Client, sans préavis ni indemnité, en cas de :</p>
      <ul>
        <li>Non-respect des présentes CGU</li>
        <li>Utilisation abusive ou frauduleuse des Services</li>
        <li>Utilisation susceptible de porter atteinte aux droits de tiers</li>
        <li>Non-paiement des sommes dues au titre de l'utilisation des Services</li>
      </ul>
    </section>

    <section class="cgu-section">
      <h2>Article 5 - Limites d'utilisation</h2>

      <h3>5.1 Quotas de requêtes</h3>
      <p>Les Services sont soumis à des limites d'utilisation qui varient selon la formule d'abonnement choisie par le Client :</p>
      <ul>
        <li>Formule Premium : Illimité</li>
        <li>Formule Étudiant : 25 requêtes par mois</li>
      </ul>
      <p>Une requête correspond à une question posée à l'intelligence artificielle ou à l'analyse d'un document juridique.</p>
      <p>Les requêtes non utilisées au cours d'un mois ne sont pas reportées au mois suivant, sauf mention contraire dans les conditions particulières applicables à la formule d'abonnement choisie.</p>

      <h3>5.2 Limites techniques</h3>
      <p>L'Exploitant s'efforce de maintenir les Services accessibles 24 heures sur 24 et 7 jours sur 7. Toutefois, l'accès aux Services peut être suspendu, limité ou interrompu à tout moment, notamment pour des raisons de maintenance, de mise à jour ou d'amélioration des Services.</p>
      <p>L'Exploitant ne pourra être tenu responsable des difficultés ou impossibilités momentanées d'accès aux Services qui auraient pour origine des circonstances extérieures à l'Exploitant, la force majeure, ou encore qui seraient dues à des perturbations des réseaux de télécommunication.</p>
    </section>

    <section class="cgu-section">
      <h2>Article 6 - Responsabilité</h2>

      <h3>6.1 Responsabilité de l'Exploitant</h3>
      <p>Les Services sont fournis "en l'état" et "selon disponibilité" sans garantie d'aucune sorte. L'Exploitant ne garantit pas que les Services seront ininterrompus, opportuns, sûrs ou exempts d'erreur.</p>
      <p>En particulier, l'Exploitant ne garantit pas :</p>
      <ul>
        <li>L'exactitude, l'exhaustivité ou la pertinence des informations et contenus fournis par les Services</li>
        <li>L'adéquation des Services aux besoins spécifiques du Client</li>
        <li>La capacité des Services à aider le Client à atteindre les résultats souhaités</li>
      </ul>
      <div class="warning-box">
        <h4>AVERTISSEMENT IMPORTANT</h4>
        <p>Les Services proposés par Query Juriste constituent un outil d'aide à la recherche juridique et ne sauraient en aucun cas se substituer aux conseils d'un professionnel du droit. L'Exploitant ne pourra être tenu responsable des décisions prises par le Client sur la base des informations fournies par les Services.</p>
      </div>

      <h3>6.2 Limitation de responsabilité</h3>
      <p>Dans toute la mesure permise par la loi applicable, l'Exploitant ne pourra être tenu responsable des dommages indirects, accessoires, spéciaux, consécutifs ou punitifs, y compris, sans limitation, la perte de profits, de données, d'utilisation, de clientèle ou d'autres pertes intangibles, résultant de :</p>
      <ul>
        <li>L'utilisation ou l'impossibilité d'utiliser les Services</li>
        <li>Tout contenu obtenu à partir des Services</li>
        <li>Tout accès non autorisé à vos données</li>
        <li>Toute interruption ou cessation des Services</li>
      </ul>
      <p>Dans tous les cas, la responsabilité de l'Exploitant sera limitée au montant payé par le Client pour l'utilisation des Services au cours des 12 mois précédant l'événement donnant lieu à responsabilité.</p>

      <h3>6.3 Force majeure</h3>
      <p>L'Exploitant ne pourra être tenu responsable de tout retard ou manquement à ses obligations résultant de circonstances relevant de la force majeure, telle que définie par l'article 1218 du Code civil et la jurisprudence des tribunaux français.</p>
    </section>

    <section class="cgu-section">
      <h2>Article 7 - Propriété intellectuelle</h2>

      <h3>7.1 Propriété du Site et des Services</h3>
      <p>Le Site et les Services, y compris, sans limitation, les textes, graphiques, images, logos, icônes de boutons, logiciels et noms de domaine, sont la propriété exclusive de l'Exploitant ou de ses concédants de licence et sont protégés par les lois françaises et internationales relatives à la propriété intellectuelle.</p>
      <p>Toute reproduction, distribution, modification, adaptation, retransmission ou publication, même partielle, de ces différents éléments est strictement interdite sans l'accord écrit préalable de l'Exploitant.</p>

      <h3>7.2 Licence d'utilisation</h3>
      <p>L'Exploitant accorde au Client une licence non exclusive, non transférable et limitée pour accéder au Site et utiliser les Services, sous réserve du respect des présentes CGU et du paiement des frais applicables.</p>
      <p>Cette licence ne confère au Client aucun droit de propriété sur le Site ou les Services, et n'autorise pas le Client à :</p>
      <ul>
        <li>Copier, modifier, adapter ou traduire tout ou partie du Site ou des Services</li>
        <li>Décompiler, désassembler ou procéder à une ingénierie inverse de tout ou partie du Site ou des Services</li>
        <li>Créer des œuvres dérivées basées sur tout ou partie du Site ou des Services</li>
        <li>Utiliser le Site ou les Services à des fins commerciales sans l'autorisation préalable et écrite de l'Exploitant</li>
      </ul>

      <h3>7.3 Propriété des contenus fournis par le Client</h3>
      <p>Le Client conserve tous les droits de propriété intellectuelle sur les contenus qu'il soumet, publie ou affiche sur ou via les Services.</p>
      <p>En soumettant, publiant ou affichant des contenus sur ou via les Services, le Client accorde à l'Exploitant une licence mondiale, non exclusive, gratuite, pour utiliser, héberger, stocker, reproduire, modifier, créer des œuvres dérivées, communiquer, publier, afficher publiquement et distribuer ces contenus, uniquement dans le but de fournir et d'améliorer les Services.</p>
    </section>

    <section class="cgu-section">
      <h2>Article 8 - Protection des données personnelles</h2>
      <p>L'Exploitant accorde une grande importance à la protection des données personnelles du Client. La collecte et le traitement des données personnelles du Client sont régis par la Politique de Confidentialité de l'Exploitant, accessible à l'adresse suivante : [URL de la Politique de Confidentialité].</p>
    </section>

    <section class="cgu-section">
      <h2>Article 9 - Durée et résiliation</h2>

      <h3>9.1 Durée</h3>
      <p>Les présentes CGU sont conclues pour une durée indéterminée à compter de l'acceptation par le Client.</p>

      <h3>9.2 Résiliation à l'initiative du Client</h3>
      <p>Le Client peut résilier les présentes CGU à tout moment en supprimant son Compte ou en cessant d'utiliser les Services. La résiliation prendra effet immédiatement, sans préjudice des dispositions qui, par leur nature, sont destinées à survivre à la résiliation des présentes CGU.</p>
      <p>La résiliation des présentes CGU n'entraîne pas automatiquement la résiliation de l'abonnement du Client, qui reste soumise aux Conditions Générales de Vente.</p>

      <h3>9.3 Résiliation à l'initiative de l'Exploitant</h3>
      <p>L'Exploitant peut résilier les présentes CGU à tout moment, sans préavis ni indemnité, en cas de :</p>
      <ul>
        <li>Non-respect par le Client des présentes CGU</li>
        <li>Utilisation frauduleuse ou abusive des Services</li>
        <li>Comportement préjudiciable aux intérêts de l'Exploitant ou de tiers</li>
      </ul>
      <p>L'Exploitant se réserve également le droit de résilier les présentes CGU à tout moment, pour quelque motif que ce soit, moyennant un préavis de 30 jours notifié au Client par email.</p>

      <h3>9.4 Conséquences de la résiliation</h3>
      <p>En cas de résiliation des présentes CGU, pour quelque cause que ce soit :</p>
      <ul>
        <li>Le Client perdra immédiatement le droit d'accéder et d'utiliser les Services</li>
        <li>Les dispositions des présentes CGU qui, par leur nature, sont destinées à survivre à la résiliation continueront de s'appliquer</li>
        <li>L'Exploitant pourra supprimer toutes les données associées au Compte du Client, à l'exception de celles qu'il est légalement tenu de conserver</li>
      </ul>
    </section>

    <section class="cgu-section">
      <h2>Article 10 - Modification des CGU</h2>
      <p>L'Exploitant se réserve le droit de modifier les présentes CGU à tout moment. Les nouvelles CGU entreront en vigueur dès leur publication sur le Site.</p>
      <p>Le Client sera informé des modifications par email ou par un message sur le Site. Si le Client continue à utiliser les Services après l'entrée en vigueur des nouvelles CGU, il sera réputé avoir accepté ces modifications.</p>
      <p>Si le Client n'accepte pas les nouvelles CGU, il devra cesser d'utiliser les Services et supprimer son Compte.</p>
    </section>

    <section class="cgu-section">
      <h2>Article 11 - Service client et réclamations</h2>
      <p>Pour toute question ou réclamation relative aux Services, le Client peut contacter l'Exploitant :</p>
      <ul>
        <li>Par email à l'adresse suivante : etienneleguay@query-juriste.com</li>
        <li>Par téléphone au numéro suivant : +33782178073 (heures d'ouverture : Lundi-Samedi, 9h-17h)</li>
      </ul>
    </section>

    <section class="cgu-section">
      <h2>Article 12 - Dispositions diverses</h2>

      <h3>12.1 Indépendance des clauses</h3>
      <p>Si une ou plusieurs stipulations des présentes CGU sont tenues pour non valides ou déclarées comme telles en application d'une loi, d'un règlement ou d'une décision définitive d'une juridiction compétente, les autres stipulations garderont toute leur force et leur portée.</p>

      <h3>12.2 Non-renonciation</h3>
      <p>Le fait pour l'une des parties de ne pas se prévaloir d'un manquement par l'autre partie à l'une quelconque des obligations visées dans les présentes CGU ne saurait être interprété pour l'avenir comme une renonciation à l'obligation en cause.</p>

      <h3>12.3 Loi applicable et juridiction compétente</h3>
      <p>Les présentes CGU sont régies par le droit français.</p>
      <p>En cas de litige relatif à la formation, l'interprétation, l'exécution ou la résiliation des présentes CGU, les parties s'efforceront de trouver une solution amiable.</p>
      <p>À défaut d'accord amiable, tout litige sera soumis à la compétence exclusive des tribunaux français compétents, nonobstant pluralité de défendeurs ou appel en garantie.</p>

      <h3>12.4 Médiation</h3>
      <p>Conformément aux dispositions du Code de la consommation concernant le règlement amiable des litiges, le Client peut recourir gratuitement au service de médiation proposé par l'Exploitant. Le médiateur "droit de la consommation" ainsi proposé est [Nom du médiateur].</p>
      <h3>12.5 Langue</h3>
      <p>Les présentes CGU sont rédigées en langue française. Dans le cas où elles seraient traduites en une ou plusieurs langues étrangères, seul le texte français ferait foi en cas de litige.</p>
    </section>

    <section class="cgu-section">
      <h2>Article 13 - Contact</h2>
      <p>Pour toute question relative aux présentes CGU, le Client peut contacter l'Exploitant aux coordonnées suivantes :</p>
      <ul>
        <li>Adresse : 37 rue rousselet, 75007 Paris</li>
        <li>Email : etienneleguay@query-juriste.com</li>
        <li>Téléphone : +33782178073</li>
      </ul>
    </section>

    <div class="acceptance-box">
      <p>En acceptant les présentes CGU, le Client reconnaît en avoir pris connaissance et les accepter sans réserve.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConditionsUtilisation',
  data() {
    return {
      acceptedTerms: false,
      currentDate: new Date().toLocaleDateString('fr-FR')
    }
  },
  methods: {
    toggleAcceptance() {
      this.acceptedTerms = !this.acceptedTerms;
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString('fr-FR');
    }
  }
}
</script>

<style scoped>
.cgu-container {
  font-family: 'Roboto', Arial, sans-serif;
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
  color: #333;
  line-height: 1.6;
  background-color: white;
}

.cgu-title {
  text-align: center;
  font-size: 28px;
  color: #2c3e50;
  margin-bottom: 10px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eaeaea;
}

.cgu-date {
  text-align: center;
  font-style: italic;
  color: #666;
  margin-bottom: 30px;
}

.cgu-section {
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eaeaea;
}

.cgu-section h2 {
  color: #2c3e50;
  font-size: 22px;
  margin-top: 20px;
  margin-bottom: 15px;
}

.cgu-section h3 {
  color: #3498db;
  font-size: 18px;
  margin-top: 15px;
  margin-bottom: 10px;
}

.cgu-section h4 {
  color: #2c3e50;
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 8px;
}

.cgu-section p {
  margin-bottom: 10px;
  text-align: justify;
}

.cgu-section ul {
  margin-bottom: 15px;
  padding-left: 20px;
}

.cgu-section li {
  margin-bottom: 5px;
}

.cgu-section a {
  color: #3498db;
  text-decoration: none;
}

.cgu-section a:hover {
  text-decoration: underline;
}

.warning-box {
  background-color: #fff8f8;
  border-left: 4px solid #e74c3c;
  padding: 15px;
  margin: 20px 0;
  border-radius: 0 4px 4px 0;
}

.warning-box h4 {
  color: #e74c3c;
  margin-top: 0;
}

.acceptance-box {
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  padding: 15px;
  margin-top: 30px;
  border-radius: 4px;
  text-align: center;
}

@media (max-width: 768px) {
  .cgu-container {
    padding: 15px;
  }

  .cgu-title {
    font-size: 24px;
  }

  .cgu-section h2 {
    font-size: 20px;
  }

  .cgu-section h3 {
    font-size: 16px;
  }
}
</style>
